module.exports = __webpack_public_path__ + "img/undraw_Designer_by46 (1).b4d0daa5.svg";